import type { IntegrationSignal, StackSignal } from "./types";

function has(paths: readonly string[], pattern: RegExp): string[] {
  return paths.filter((path) => pattern.test(path));
}

export function detectStackSignals(paths: readonly string[]): StackSignal[] {
  const signals: StackSignal[] = [];

  const packageJson = has(paths, /(^|\/)package\.json$/i);

  const tsconfig = has(paths, /(^|\/)tsconfig[^/]*\.json$/i);

  const vite = has(paths, /(^|\/)vite\.config\./i);

  const supabase = has(paths, /(^|\/)supabase\//i);

  const github = has(paths, /(^|\/)\.github\/workflows\//i);

  const rust = has(paths, /(^|\/)cargo\.toml$/i);

  const python = has(paths, /(^|\/)(requirements\.txt|pyproject\.toml)$/i);

  if (packageJson.length) {
    signals.push({
      technology: "Node.js ecosystem",
      evidence: packageJson,
      confidence: "high",
    });
  }

  if (tsconfig.length) {
    signals.push({
      technology: "TypeScript",
      evidence: tsconfig,
      confidence: "high",
    });
  }

  if (vite.length) {
    signals.push({
      technology: "Vite",
      evidence: vite,
      confidence: "high",
    });
  }

  if (supabase.length) {
    signals.push({
      technology: "Supabase",
      evidence: supabase.slice(0, 20),
      confidence: "high",
    });
  }

  if (github.length) {
    signals.push({
      technology: "GitHub Actions",
      evidence: github.slice(0, 20),
      confidence: "high",
    });
  }

  if (rust.length) {
    signals.push({
      technology: "Rust",
      evidence: rust,
      confidence: "high",
    });
  }

  if (python.length) {
    signals.push({
      technology: "Python",
      evidence: python,
      confidence: "high",
    });
  }

  return signals;
}

export function detectIntegrationSignals(
  paths: readonly string[],
): IntegrationSignal[] {
  const signals: IntegrationSignal[] = [];

  const github = has(paths, /(^|\/)\.github\//i);

  const supabase = has(paths, /(^|\/)supabase\//i);

  const cloudflare = has(paths, /(^|\/)(wrangler\.jsonc?|cloudflare)/i);

  if (github.length) {
    signals.push({
      integration: "GitHub",
      evidence: github.slice(0, 20),
      requiresCapability: "github-read",
    });
  }

  if (supabase.length) {
    signals.push({
      integration: "Supabase",
      evidence: supabase.slice(0, 20),
      requiresCapability: "supabase-read",
    });
  }

  if (cloudflare.length) {
    signals.push({
      integration: "Cloudflare",
      evidence: cloudflare.slice(0, 20),
      requiresCapability: "cloudflare-read",
    });
  }

  return signals;
}
